export class ProcessedTransactionRequest
{
    kioskId: string;
    tenantId: string;
    endDate: string;
    startDate: string;
}



